export const COMPANY = {
  name: 'MasterTech Educational',
  shortName: 'MasterTech',
  tagline: 'Your Gateway to Global Education Excellence',
  tagline2: 'Engineering Dreams, Building Futures Worldwide',
  description:
    "MasterTech Educational is Hyderabad's premier study abroad consultancy — offering end-to-end guidance from university shortlisting and SOP writing to visa filing and loan assistance. We don't just help you apply. We help you succeed.",
  founded: 2019,
  phone: '+91 9398257576',
  email: 'Mastertecheducational@gmail.com',
  address: 'Manjeera Trinity Corporate, Kukatpally, Hyderabad, Telangana, India',
  addressShort: 'Kukatpally, Hyderabad',
  hours: 'Mon–Sat: 9:00 AM – 7:00 PM',
  whatsapp: '+919398257576',
  social: {
    instagram: 'https://instagram.com/mastertechoverseas',
  },
};

export const testimonials = [
  {
    id: 1,
    name: 'Venkata Sai Krishnamurthy',
    university: 'University of Manchester',
    country: 'United Kingdom',
    flag: '🇬🇧',
    course: 'MSc Artificial Intelligence',
    year: '2024',
    quote:
      'MasterTech handled everything — from my university shortlist to visa approval. The SOP they crafted got me into my first-choice university. Truly exceptional guidance throughout.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ananya Krishnaswamy',
    university: 'University of Toronto',
    country: 'Canada',
    flag: '🇨🇦',
    course: 'MBA — Finance',
    year: '2024',
    quote:
      'I was overwhelmed choosing between UK and Canada. The team patiently analyzed my profile and helped me get a 35% scholarship at UofT. Best decision I ever made — choosing MasterTech.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Rohan Teja Bandaru',
    university: 'University of Melbourne',
    country: 'Australia',
    flag: '🇦🇺',
    course: 'MS Data Engineering',
    year: '2024',
    quote:
      "The loan assistance from MasterTech was a lifesaver. They got me an education loan from HDFC Credila at the best possible rate with zero processing fee. Couldn't have done it without them.",
    rating: 5,
  },
  {
    id: 4,
    name: 'Sowmya Reddy Nallamothu',
    university: 'TU Munich',
    country: 'Germany',
    flag: '🇩🇪',
    course: 'MS Mechanical Engineering',
    year: '2024',
    quote:
      "Germany felt like an impossible dream given the tuition cost concerns. MasterTech showed me that public universities in Germany are essentially free. Now I'm studying at TU Munich — one of the best in the world!",
    rating: 5,
  },
  {
    id: 5,
    name: 'Harsha Vardhan Polu',
    university: 'Trinity College Dublin',
    country: 'Ireland',
    flag: '🇮🇪',
    course: 'MSc Computer Science',
    year: '2024',
    quote:
      'The mock visa interview sessions at MasterTech prepared me so well — I walked into the real interview with zero anxiety. Visa approved in 3 weeks. Highly recommend MasterTech to every aspiring student!',
    rating: 5,
  },
  {
    id: 6,
    name: 'Meghana Apparao',
    university: 'ETH Zurich',
    country: 'Switzerland',
    flag: '🇨🇭',
    course: 'MS Computer Science',
    year: '2024',
    quote:
      "Getting into ETH Zurich seemed like a stretch goal. MasterTech's consultants helped me position my profile strategically, write a standout SOP, and navigate the complex Swiss application — and I got in!",
    rating: 5,
  },
];

export const universityLogos = [
  { name: 'University of Manchester', country: 'UK', qsRank: 32, color: '#660099' },
  { name: 'University of Toronto', country: 'Canada', qsRank: 21, color: '#002A5C' },
  { name: 'University of Melbourne', country: 'Australia', qsRank: 14, color: '#094183' },
  { name: 'TU Munich', country: 'Germany', qsRank: 37, color: '#0065BD' },
  { name: 'Trinity College Dublin', country: 'Ireland', qsRank: 81, color: '#003D6B' },
  { name: 'ETH Zurich', country: 'Switzerland', qsRank: 7, color: '#1F407A' },
  { name: 'University College London', country: 'UK', qsRank: 9, color: '#500778' },
  { name: 'University of British Columbia', country: 'Canada', qsRank: 34, color: '#002145' },
  { name: 'University of Sydney', country: 'Australia', qsRank: 19, color: '#CC0000' },
  { name: 'RWTH Aachen', country: 'Germany', qsRank: 106, color: '#00549F' },
  { name: 'University College Dublin', country: 'Ireland', qsRank: 171, color: '#004990' },
  { name: 'EPFL', country: 'Switzerland', qsRank: 17, color: '#E1251B' },
];

export const services = [
  {
    id: 1,
    title: 'Visa Assistance',
    slug: 'visa-assistance',
    description:
      'Complete ownership of your student visa journey — from form filling and document preparation to embassy appointments and mock interview coaching.',
    icon: '🛂',
    number: '01',
    features: ['Personalized visa checklist', 'Document preparation & review', 'Mock visa interview coaching', 'Appointment booking & tracking'],
  },
  {
    id: 2,
    title: 'Loan Assistance',
    slug: 'loan-assistance',
    description:
      'Connect with 50+ trusted banks and NBFCs including SBI, HDFC Credila, Axis, ICICI, Avanse, and InCred — securing the lowest interest rates with zero processing fees.',
    icon: '🏦',
    number: '02',
    features: ['50+ lending partners', 'Collateral & non-collateral loans', 'Lowest interest rate negotiation', 'Zero processing fees guidance'],
  },
  {
    id: 3,
    title: 'SOP Assistance',
    slug: 'sop-assistance',
    description:
      'Certified content specialists craft powerful, personalized Statements of Purpose that highlight your unique strengths, goals, and story — designed to make top universities say yes.',
    icon: '✍️',
    number: '03',
    features: ['100% original content', 'Tailored to university guidelines', '2–3 revision rounds', 'Plagiarism-free guarantee'],
  },
  {
    id: 4,
    title: 'Scholarship Guidance',
    slug: 'scholarship-assistance',
    description:
      'Identify, match, and apply for university, government, and merit-based scholarships across all 7 destination countries — reducing your financial burden significantly.',
    icon: '🏆',
    number: '04',
    features: ['Eligibility mapping', 'Scholarship essay writing', 'Deadline management', 'Full application support'],
  },
  {
    id: 5,
    title: 'Course Selection',
    slug: 'course-selection',
    description:
      "Profile-matched course and university shortlisting based on your academic background, career goals, and budget — maximizing your admission probability.",
    icon: '🎯',
    number: '05',
    features: ['Profile-matched shortlisting', 'Career outcome analysis', 'Budget-aware recommendations', 'Ranking & accreditation checks'],
  },
  {
    id: 6,
    title: 'University Application',
    slug: 'university-application',
    description:
      'End-to-end application management — completing forms, uploading documents, tracking deadlines, and following up with admissions offices.',
    icon: '🏛️',
    number: '06',
    features: ['Multi-university management', 'Deadline tracking system', 'Offer letter follow-up', 'Conditional offer guidance'],
  },
  {
    id: 7,
    title: 'Pre-Departure Briefing',
    slug: 'pre-departure',
    description:
      'Comprehensive session covering accommodation, local banking, essential apps, cultural tips, university enrollment steps, and emergency contacts in your destination country.',
    icon: '✈️',
    number: '07',
    features: ['Accommodation guidance', 'Local SIM & banking setup', 'University check-in process', 'Cultural orientation tips'],
  },
  {
    id: 8,
    title: 'Post-Arrival Support',
    slug: 'post-arrival',
    description:
      "Our support extends beyond your departure gate — helping with enrollment, local orientation, and connecting you with our alumni network in your city.",
    icon: '🤝',
    number: '08',
    features: ['University enrollment help', 'Alumni network connection', 'Local orientation guidance', 'Emergency support line'],
  },
  {
    id: 9,
    title: 'Work Permit Assistance',
    slug: 'work-permit',
    description:
      'Expert guidance on PGWP (Canada), PSW Route (UK), OPT/CPT (USA), Graduate Visa (Australia), and Job Seeker Visa (Germany) — capitalizing on your degree globally.',
    icon: '📋',
    number: '09',
    features: ['PGWP guidance (Canada)', 'PSW Route (UK)', 'OPT/CPT support (USA)', 'Graduate Visa (Australia)'],
  },
  {
    id: 10,
    title: 'PR / Skilled Migration',
    slug: 'pr-migration',
    description:
      'Dedicated PR and skilled migration guidance for Australia and Canada — covering Express Entry, Provincial Nominee Programs (PNP), and Skilled Independent visa pathways.',
    icon: '🌐',
    number: '10',
    features: ['Express Entry (Canada)', 'Provincial Nominee Programs', 'Skilled Independent (Australia)', 'Points-based assessment'],
  },
];

export const destinations = [
  {
    name: 'United Kingdom',
    shortName: 'UK',
    code: 'gb',
    flag: '🇬🇧',
    slug: 'uk',
    badge: 'Most Popular',
    badgeColor: 'bg-purple-500',
    universities: '160+',
    avgTuition: '£12,000 – £35,000/yr',
    intake: 'Jan & Sep',
    highlight: '1-Year Masters • Graduate Route Visa',
    stat: '4 of Top 10 QS Ranked Universities',
    topUnis: ['University of Roehampton', 'UCL', 'University of Manchester'],
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&q=80',
    continent: 'Europe',
  },
  {
    name: 'United States',
    shortName: 'USA',
    code: 'us',
    flag: '🇺🇸',
    slug: 'usa',
    badge: 'Top Research Hub',
    badgeColor: 'bg-blue-600',
    universities: '4,000+',
    avgTuition: '$20,000 – $55,000/yr',
    intake: 'Jan, Aug & Sep',
    highlight: 'OPT 3-Year STEM Work Authorization',
    stat: '4,000+ Accredited Universities',
    topUnis: ['MIT', 'Stanford', 'Cornell', 'University of Illinois'],
    image: 'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=800&q=80',
    continent: 'North America',
  },
  {
    name: 'Canada',
    shortName: 'Canada',
    code: 'ca',
    flag: '🇨🇦',
    slug: 'canada',
    badge: 'Best for PR',
    badgeColor: 'bg-red-600',
    universities: '100+',
    avgTuition: 'CAD 15,000 – 40,000/yr',
    intake: 'Jan, May & Sep',
    highlight: 'PGWP 3 Years + Express Entry PR',
    stat: 'Affordable Tuition + Multicultural',
    topUnis: ['University of Toronto', 'UBC', 'McGill', 'McMaster'],
    image: 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=800&q=80',
    continent: 'North America',
  },
  {
    name: 'Australia',
    shortName: 'Australia',
    code: 'au',
    flag: '🇦🇺',
    slug: 'australia',
    badge: 'Work While Study',
    badgeColor: 'bg-yellow-600',
    universities: '43',
    avgTuition: 'AUD 20,000 – 45,000/yr',
    intake: 'Feb & Jul',
    highlight: '2–4 Year Post-Study Work Visa',
    stat: 'Group of Eight Elite Universities',
    topUnis: ['University of Melbourne', 'UNSW', 'ANU', 'Monash'],
    image: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=800&q=80',
    continent: 'Oceania',
  },
  {
    name: 'Germany',
    shortName: 'Germany',
    code: 'de',
    flag: '🇩🇪',
    slug: 'germany',
    badge: 'Tuition Free',
    badgeColor: 'bg-gray-700',
    universities: '400+',
    avgTuition: '€0 – €3,000/yr (Public)',
    intake: 'Apr & Oct',
    highlight: 'Zero Tuition at Public Universities',
    stat: '18-Month Post-Study Job Seeker Visa',
    topUnis: ['TU Munich', 'LMU Munich', 'Heidelberg', 'RWTH Aachen'],
    image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800&q=80',
    continent: 'Europe',
  },
  {
    name: 'Switzerland',
    shortName: 'Switzerland',
    code: 'ch',
    flag: '🇨🇭',
    slug: 'switzerland',
    badge: 'Elite Rankings',
    badgeColor: 'bg-red-700',
    universities: '12',
    avgTuition: 'CHF 1,000 – 30,000/yr',
    intake: 'Feb & Sep',
    highlight: 'ETH Zurich: Top 7 Globally',
    stat: 'Finance, Hospitality & Tech Hub',
    topUnis: ['ETH Zurich', 'EPFL', 'University of Zurich'],
    image: 'https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=800&q=80',
    continent: 'Europe',
  },
  {
    name: 'Ireland',
    shortName: 'Ireland',
    code: 'ie',
    flag: '🇮🇪',
    slug: 'ireland',
    badge: 'Tech Capital',
    badgeColor: 'bg-green-700',
    universities: '34',
    avgTuition: '€10,000 – €25,000/yr',
    intake: 'Jan & Sep',
    highlight: '2-Year Stay Back + EU Gateway',
    stat: "HQs of Google, Meta, Apple & LinkedIn",
    topUnis: ['Trinity College Dublin', 'UCD', 'DCU', 'UCC'],
    image: 'https://images.unsplash.com/photo-1564959130747-897fb406b9af?w=800&q=80',
    continent: 'Europe',
  },
];

export const processSteps = [
  {
    step: 1,
    title: 'Free Consultation',
    icon: '🗣️',
    description:
      'Book a free 1-on-1 session with our expert consultants. We understand your goals, budget, academic background, and preferred destinations.',
  },
  {
    step: 2,
    title: 'Profile Evaluation & Shortlisting',
    icon: '📋',
    description:
      'We analyze your complete profile and shortlist the best-fit universities, courses, and countries — with scholarship opportunities aligned to your eligibility.',
  },
  {
    step: 3,
    title: 'Application & Documentation',
    icon: '📄',
    description:
      'We handle your entire application process — SOP, LOR, university forms, financial documents, visa paperwork — ensuring zero errors and on-time submissions.',
  },
  {
    step: 4,
    title: 'Visa Approval & Pre-Departure',
    icon: '✈️',
    description:
      'From visa filing to mock interviews to pre-departure briefing — we support you until you board your flight with complete confidence.',
  },
];

export const whyChooseUs = [
  {
    icon: '🎓',
    title: 'Expert Consultants',
    description:
      'Our team includes consultants who are themselves international alumni — giving you real, firsthand guidance backed by lived experience.',
  },
  {
    icon: '✅',
    title: '98% Visa Success Rate',
    description:
      'Our meticulous documentation, thorough profile review, and mock interview preparation deliver a visa success rate that stands among the highest in the industry.',
  },
  {
    icon: '🔄',
    title: 'End-to-End Support',
    description:
      "We are with you from day one to day one abroad. Our support doesn't end at visa approval — it extends to your first day on campus.",
  },
  {
    icon: '💯',
    title: 'Zero Hidden Charges',
    description:
      'Complete transparency in pricing. No surprise fees. No unnecessary upsells. Just honest, expert guidance that delivers results.',
  },
  {
    icon: '🏛️',
    title: '50+ Partner Universities',
    description:
      'Our partnerships with 50+ universities globally give students priority processing, exclusive scholarship access, and direct admission support.',
  },
  {
    icon: '🎯',
    title: 'Personalized Approach',
    description:
      'No two students are the same. Every guidance plan at MasterTech is 100% tailored — your goals, your profile, your dream.',
  },
];
